import clsx from "clsx";
import React from "react";
import useLanguageChange from "../../hooks/useLanguageChange";

import extractTextService from "../../services/extractTextService";

const PrepareExtractText = (showPrepareView) => {
    const localisedValues = useLanguageChange();

    const sendCancelMarkupOCRPrepareView = () => {
        extractTextService.sendCancelMarkupOCRPrepareView("OCR");
    };

    return (
        <div className={clsx("process-waiting annotation-process-waiting", !showPrepareView && "d-none")} data-testid='extractText-prepare-component'>
            <div className='process-waiting-in custom-scroll'>
                <div className='process-waiting-box text-center'>
                    <div className='process-waiting-icon'>
                        <span className='for-icon icon-extract-text'></span>
                    </div>
                    <div className='process-waiting-text'>
                        <div className='process-waiting-text-bar'>{localisedValues?.preparing_image_for_OCR}</div>
                    </div>
                    <div className='process-waiting-text-bottom' id='timeOutScreen_OCR' style={{ display: "none" }}>
                        <div className='process-waiting-text-bottom-bar'>{localisedValues?.markup_ocr_upload_timeout}</div>
                        <div className='process-waiting-text-bottom-bar'>
                            <button className='btn' onClick={sendCancelMarkupOCRPrepareView}>
                                {localisedValues?.click_here}
                            </button>
                            {localisedValues?.to_return_to_video_and_try_again}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrepareExtractText;
